/**
 * EVERY BRAND IN THE READER'S SCOPE, IN WORDS.
 *
 * Screens wrote "All N brands" with N the brands the reader can see, so an admin held to one brand
 * read "All 1 brands", "All 1" in the header and "scoped to all brands" (module walk, 30 Oct 2026).
 * One brand is named; several are counted, plural; none known yet carries no number, never one made
 * up.
 */
type Named = { name: string };

/** As a label, capitalised: "All 3 brands", "FairPlay", "All brands". */
export function allBrandsLabel(brands: readonly Named[]): string {
  if (brands.length === 1) return brands[0]!.name;
  return brands.length > 1 ? `All ${brands.length} brands` : 'All brands';
}

/** Inside a sentence: "all 3 brands", "FairPlay", "all brands". */
export function allBrandsPhrase(brands: readonly Named[]): string {
  if (brands.length === 1) return brands[0]!.name;
  return brands.length > 1 ? `all ${brands.length} brands` : 'all brands';
}
